<template>
  <Ethereum :callback="initialize" />
  <div class="burn">
    <div class="container" v-if="store.state.ethers.address">
      <div class="descriptionWrapper">
        <div class="title">Re-Roll Iron Bull</div>
        <div class="subtitle">
          Re-rolling your Iron Bull will allow you to claim a new Iron Bull with
          different traits.<br />Select the Iron Bulls you would like to
          re-roll:<br /><br />
        </div>
        <div class="claimChecker">
          <div class="label">Check reroll status:</div>
          <TextInput
            v-model="bullId"
            placeholder="Enter a bull ID number"
            class="textInput"
          />
          <Button @click="checkReroll(bullId)">Check</Button>
        </div>
        <div v-if="checked && !rerolled" class="status">
          This Iron Bull has not been rerolled yet!
        </div>
        <div v-if="checked && rerolled" class="status claimed">
          This Iron Bull has already been rerolled or you entered an invalid
          Iron Bull ID. <br />
          Your Bull ID is the number in your Astro Bull name.
        </div>
      </div>

      <div class="itemsGrid">
        <NFTCard
          :fren="fren"
          v-for="fren in frens"
          :key="fren.id"
          @click.prevent="toggleSelection(fren)"
          :class="fren.isSelected ? 'selected' : ''"
          :style="isFrenClaimed(fren) ? { cursor: 'initial' } : ''"
          :isIronBull="true"
          :isClaimed="isFrenClaimed(fren)"
        />
      </div>

      <LoadingSpinnerIcon v-if="loading" />

      <div class="burnButtonWrapper">
        <Button v-if="selectedFrens.length > 0" @click="reRoll">
          Re-roll {{ selectedFrens.length }} {{ bullLabel }}
        </Button>
      </div>
      <!-- <div class="faq">FAQ</div> -->
      <div class="dropdownWrapper" v-for="item in faq" :key="item.title">
        <animated-component>
          <DropdownItem :title="item.title" :description="item.description" />
        </animated-component>
      </div>
    </div>
    <ConnectWallet v-else />
  </div>
</template>
<script>
'use strict';

// Imports.
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

// Component imports.
import ConnectWallet from '/src/components/common/ConnectWallet.vue';
import NFTCard from '../my-frens/components/NFTCard.vue';
import Ethereum from '/src/components/common/Ethereum.vue';
import Button from '/src/components/ui/Button.vue';
import DropdownItem from '/src/pages/home/components/DropdownItem.vue';
import LoadingSpinnerIcon from '/src/components/icons/LoadingSpinnerIcon.vue';
import TextInput from '/src/components/ui/TextInput.vue';

export default {
  components: {
    ConnectWallet,
    NFTCard,
    Ethereum,
    Button,
    DropdownItem,
    LoadingSpinnerIcon,
    TextInput
  },

  setup() {
    const bullId = ref('');
    const store = useStore();
    const router = useRouter();
    const selected = ref();
    const checked = ref(false);
    const rerolled = ref(false);

    const loading = ref(false);
    if (store.state.mint.frens.length === 0) loading.value = true;
    // Once the state variable changes, the watch is triggered.
    watch(
      () => store.state.mint.frens,
      selection => {
        loading.value = false;
      }
    );

    // Retrieve the the user's owned frens.
    const initialize = async () => {
      console.log(store.state.ethers.canSign);
      if (store.state.ethers.canSign) {
        const address = store.state.ethers.address;
        await store.dispatch(
          'mint/getFrens',
          {
            address,
            collectionAddress: '0x71B11Ac923C967CD5998F23F6dae0d779A6ac8Af',
            groupId: 1
          },
          { root: true }
        );
        await store.dispatch('claim/getRedeemedIronBulls', {}, { root: true });
      }
    };

    const frens = computed(() => {
      let ironBulls = store.state.mint.frens.filter(fren => {
        for (let attribute of fren.metadata.attributes) {
          if (
            attribute.trait_type === 'Body Color' &&
            (attribute.value === 'IronBull (Red)' ||
              attribute.value === 'IronBull (Silver)')
          ) {
            return fren;
          }
        }
      });

      return ironBulls;
    });

    const redeemedFrenIds = computed(() => {
      var set = new Set();
      store.state.claim.redeemedFrens.redeemedBulls?.forEach(item => {
        set.add(item);
      });
      return set;
    });

    const toggleSelection = fren => {
      if (!isFrenClaimed(fren)) fren.isSelected = !fren.isSelected;
    };

    const selectedFrens = computed(() => {
      let frenIds = [];
      for (let fren of frens.value) {
        if (fren.isSelected) frenIds.push(fren.id);
      }
      return frenIds;
    });

    const bullLabel = computed(() => {
      return selectedFrens.value.length === 1 ? 'Bull' : 'Bulls';
    });

    const reRoll = () => {
      router.push({
        name: 'Confirm Iron Bull Roll',
        params: {
          frens: selectedFrens.value
        }
      });
    };

    const faq = [];

    const checkReroll = async id => {
      if (!id) return;
      let response = await store.dispatch(
        'burn/checkNotary',
        { tokenId: id },
        { root: true }
      );
      checked.value = true;
      rerolled.value = response;
    };

    const isFrenClaimed = fren => {
      return redeemedFrenIds.value.has(fren.metadata.issue);
    };

    return {
      bullId,
      frens,
      store,
      initialize,
      loading,
      selected,
      toggleSelection,
      selectedFrens,
      bullLabel,
      reRoll,
      faq,
      checked,
      rerolled,
      checkReroll,
      redeemedFrenIds,
      isFrenClaimed
    };
  }
};
</script>
<style scoped lang="scss">
.burn {
  padding: 60px 20px;
  color: white;

  .container {
    width: 1800px;
    max-width: 90%;
    margin-right: auto;
    margin-left: auto;

    .descriptionWrapper {
      display: flex;
      margin-bottom: 40px;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .title {
        margin-top: 0px;
        margin-bottom: 20px;
        font-family: Montserrat, sans-serif;
        color: #ffd915;
        font-size: 90px;
        line-height: 1em;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
      }

      .claimChecker {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;

        .label {
          white-space: nowrap;
          margin-right: 10px;
        }

        .textInput {
          margin-right: 10px;
          width: 370px;
        }
      }

      .status {
        margin-top: 10px;
        padding: 10px 20px;
        background-color: #15ff6f;
        color: #000;
        font-weight: 700;
      }

      .claimed {
        background-color: #ff1e1e;
        color: #fff;
      }
    }

    .itemsGrid {
      display: grid;
      width: 100%;
      justify-content: center;
      justify-items: center;
      grid-auto-columns: 1fr;
      grid-auto-rows: 1fr;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      grid-template-columns: repeat(auto-fit, minmax(300px, min-content));
      grid-template-rows: 1fr;

      .selected {
        box-shadow: 0 0 0 4px #15fff3;
      }
    }

    .burnButtonWrapper {
      position: sticky;
      left: 0px;
      right: 0px;
      bottom: 0px;
      z-index: 5;
      display: grid;
      min-height: 60px;
      margin-bottom: 40px;
      padding: 60px 30px;
      justify-content: center;
      justify-items: center;
      grid-auto-flow: column;
      grid-auto-columns: auto;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      grid-template-columns: auto;
      grid-template-rows: auto;
      background-image: linear-gradient(0deg, #000 50%, transparent);
    }

    .faq {
      max-width: 41ch;
      margin-right: auto;
      margin-bottom: 20px;
      margin-left: auto;
      color: #ffd915;
      font-size: 32px;
      font-weight: 700;
      text-align: center;
      text-transform: uppercase;
    }
  }
}
</style>
